import { ToastMethods } from "components/ToastNotification";
import i18n from "i18n";
import { action, observable } from "mobx";
import type { AnsweredQuestion, Question, TestResult } from "models/test/Test";
import { testRepository } from "repositories";

interface TestInterface {
  chapterTestInfo: Question[];
  testResultsInfo: TestResult[];
  loading: boolean;
  setChapterTest: (chapterTest: Question[]) => void;
  setTestResults: (testResults: TestResult[]) => void;
  setLoadingTest: (loading: boolean) => void;
  fetchChapterTest: (chapterId: string, bookId: string) => void;
  fetchTestResults: () => void;
  postTestResult: (chapterId: string, testResult: AnsweredQuestion[]) => void;
}

const initialState = {
  chapterTestInfo: [],
  testResultsInfo: [],
  currentQuestion: 1,
  loading: true,
};

const stateSetters = {
  setChapterTest: action((chapterTest: Question[]) => {
    store.chapterTestInfo = chapterTest;
  }),
  setTestResults: action((testResults: TestResult[]) => {
    store.testResultsInfo = testResults;
  }),
  setLoadingTest: action((loading: boolean) => {
    store.loading = loading;
  }),
};

const apiRequests = {
  fetchChapterTest: action((chapterId: string, bookId: string) => {
    store.setLoadingTest(true);
    testRepository
      .getChapterTest(chapterId, bookId)
      .then((chapterTest: Question[]) => {
        store.setChapterTest(chapterTest);
        store.setLoadingTest(false);
      })
      .catch(() => {
        ToastMethods.showToast(i18n.t("toast:test.error.fetchChapterTest"), "error");
      });
  }),
  fetchTestResults: action(() => {
    testRepository.getTestResults().then((testResults: TestResult[]) => {
      store.setTestResults(testResults);
    });
  }),
  postTestResult: action((chapterId: string, testResult: AnsweredQuestion[]) => {
    if (!chapterId) {
      ToastMethods.showToast(i18n.t("toast:test.error.postTestResult"), "error");
      return Promise.reject(new Error("chapterId is not defined"));
    }
    return testRepository.postTestResult(chapterId, testResult).catch(() => {
      ToastMethods.showToast(i18n.t("toast:test.error.postTestResult"), "error");
    });
  }),
};

const store: TestInterface = observable({
  ...stateSetters,
  ...apiRequests,
  ...initialState,
} as TestInterface);

export const useTest = (): TestInterface => store;
